import BaseComponent from './BaseComponent'
import Textarea from './Textarea'
import Utility from '../utilities/Utility'
import { hasVariableRules, validateInput } from '../utilities/functions/validations'

export default class PromptTextarea extends BaseComponent {
  /**
   * Prompt text area
   * @module PromptTextarea
   * @param {Object} props React props
   */
  constructor(props) {
    super(props)
    this.state = {
      value: props.value,
      lang: props.lang,
    }
    this.text = props.value
  }

  setConfig(key, value) {
    const xtras = { lang: key }
    this.updateContext(value, xtras)
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ value: nextProps.value })
    this.setState({ lang: nextProps.lang })
  }

  /**
   * React render
   * @returns {XML|Array}
   */
  render() {
    const value = this.state.value[this.state.lang];

    return (
      <Textarea
        key={Utility.uuid4()}
        context={this.props.context ?? this}
        valKey={this.props.valKey ?? this.state.lang}
        label={this.props.hideLabel ? undefined : window.apm.getLanguage(this.state.lang).name}
        lang={this.props.lang}
        value={value}
        highlight={true}
        hint={this.getPropLabel('prompt_text_here')}
        readOnly={this.props.readOnly}
        isPropertyPanel={this.props.isPropertyPanel}
        valRules={{_: (value) => validateInput(value, [hasVariableRules])}}
      />
    )
  }
}
